import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import {
  DatePicker as MuiDatePicker,
  DatePickerProps as MuiDatePickerProps,
} from '@mui/x-date-pickers/DatePicker';
import { FC, useId } from 'react';
import { FormHelperText, InputLabel, Stack, useTheme } from '@mui/material';

interface DatePickerProps<TDate> extends MuiDatePickerProps<TDate> {
  labelEmbedded?: string;
  required?: boolean;
  error?: boolean;
  helperText?: string;
}

export const DatePicker: FC<DatePickerProps<Date>> = ({
  label,
  labelEmbedded,
  required,
  error,
  helperText,
  ...rest
}) => {
  const id = useId();
  const theme = useTheme();

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <Stack gap={2} width="auto" data-testname="datePicker">
        {label && !labelEmbedded && (
          <InputLabel required={required} htmlFor={id} sx={{ ...theme.typography.inputLabel }}>
            {label}
          </InputLabel>
        )}

        <MuiDatePicker
          label={labelEmbedded && label}
          closeOnSelect
          slotProps={{ field: { clearable: true } }}
          {...rest}
        />
        {helperText && <FormHelperText error={error}>{helperText}</FormHelperText>}
      </Stack>
    </LocalizationProvider>
  );
};
